import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Sizes } from 'projects/speaker-platform/src/app/types/sizes.enum';
import { PlanningEventReasons } from '../../types/planning-event-reasons.enum';

@Component({
    selector: 'app-status-badge',
    imports: [],
    templateUrl: './status-badge.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./status-badge.component.scss']
})

export class StatusBadgeComponent {
  @Input() status!: PlanningEventReasons;
  @Input() size: Sizes = Sizes.DEFAULT;
  planningEventReasons = PlanningEventReasons
}
